/* eslint-disable react/require-default-props */

import { useSelector } from 'react-redux';

import { useTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';

import ReportTableContainer from 'reports/Common/ReportTable';
import { convertPaymentTypeDataToCashCardSplitClientTableData } from 'reports/utils';

export const CashCardSplitClientTable = ({ startDate, endDate, clients }) => {
  const { t } = useTranslation();

  const currencyAbbr = useSelector(selectCurrentSalonCurrency);

  return (
    <div id="cash-card-by-client">
      <ReportTableContainer
        startDate={startDate}
        endDate={endDate}
        title={t('businessReports.payments.splitByClientTableHeader')}
        data={{
          rows: convertPaymentTypeDataToCashCardSplitClientTableData(clients, currencyAbbr),
        }}
      />
      <br /> <br /> <br />
    </div>
  );
};
